var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"chat-input-container"},[_c('a-textarea',{attrs:{"placeholder":_vm.placeholder,"rows":1,"auto-size":{ minRows: 1, maxRows: 3 }},on:{"keydown":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter"))return null;return ((e) => {
			if (!e.shiftKey) {
				e.preventDefault();
				_vm.sendMessage();
			}
		}).apply(null, arguments)}},model:{value:(_vm.message),callback:function ($$v) {_vm.message=$$v},expression:"message"}}),_c('a-button',{attrs:{"type":"primary","disabled":!_vm.message.trim() || _vm.isLoading,"shape":"circle","icon":"arrow-right"},on:{"click":_vm.sendMessage}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }